import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from '../shell/PageHeader';
import { Notice } from '../patterns';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import StockLevelsTable from '../inventory/StockLevelsTable';

const ConsumableStockLevelsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [flash, setFlash] = useState<string | null>(null);

  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('consumables.title'), to: '/consumables/catalog' },
    { label: t('consumables.stockLevels.title') },
  ]);

  useEffect(() => {
    const incoming = (location.state as { flash?: string } | null)?.flash;
    if (incoming) {
      setFlash(incoming);
      // Clear location state so a future refresh / navigation doesn't re-show the flash.
      window.history.replaceState({}, '');
    }
  }, [location]);

  return (
    <div data-testid="consumables-stock-levels-page">
      <PageHeader
        title={t('consumables.stockLevels.title')}
        meta={t('consumables.stockLevels.meta')}
        actions={
          <>
            <button
              type="button"
              className="pat-btn pat-btn--subtle"
              onClick={() => navigate('/consumables/inventory/count')}
            >
              {t('consumables.stockCount.takeCountAction')}
            </button>
            <button
              type="button"
              className="pat-btn pat-btn--primary"
              onClick={() => navigate('/consumables/procurement/new')}
            >
              <i className="bi bi-plus-lg" aria-hidden="true" />{' '}
              {t('spray.pageHeader.actions.addStock', { defaultValue: 'Add stock' })}
            </button>
          </>
        }
      />
      {flash && (
        <Notice tone="success" testId="stock-levels-flash">
          {flash}
        </Notice>
      )}
      <StockLevelsTable />
    </div>
  );
};

export default ConsumableStockLevelsPage;
